export default __webpack_public_path__ + "static/media/mz.4c696fa4.svg";